import { roundToDecimal } from 'utils/number';

const getRange = (start: number, end: number, pointsCount: number) => {
  const yAxisRange = [];
  const rangeEnd = Math.ceil(end);
  let current = Math.floor(start);
  const interval = (rangeEnd - current) / pointsCount;
  if (interval === 0) {
    return [current - 1, rangeEnd + 1];
  }

  while (current <= rangeEnd) {
    yAxisRange.push(roundToDecimal(current, 1));
    current += interval;
  }

  return yAxisRange;
};

export const getYAxisRange = (
  start: number,
  end: number,
  pointsCount: number,
) => {
  if (pointsCount <= 0) {
    return [];
  }
  if (end < start) {
    return [];
  }

  // support "new" optimisation chart y-axis labelling
  if (start < 0 && end > 0) {
    const [inner, outer] = [Math.floor(start), Math.ceil(end)]
      .map((it) => ({ it, abs: Math.abs(it) }))
      .sort((a, b) => a.abs - b.abs)
      .map(({ it }) => it);

    const range = [
      ...getRange(-Math.abs(inner), 0, pointsCount / 2),
      ...getRange(0, Math.abs(inner), pointsCount / 2).slice(1),
    ];

    if (!range.includes(outer)) {
      range.push(outer);
    }

    const sortedRange = range.sort((a, b) => a - b);
    const interval = Math.abs(inner) / (pointsCount / 2);
    const lowerBoundDiff = -(sortedRange[0] - sortedRange[1]);

    const upperBoundDiff = sortedRange.at(-1)! - sortedRange.at(-2)!;

    if (lowerBoundDiff < interval * 0.25) {
      sortedRange.splice(1, 1);
    }
    if (upperBoundDiff < interval * 0.25) {
      sortedRange.splice(sortedRange.length - 2, 1);
    }

    return [...sortedRange];
  }

  // "old" logic - todo refactor to support operations charts
  return getRange(start, end, pointsCount);
};

export const isEmptyRecordOfArrays = (data: Record<string, any[]>) =>
  Object.values(data).every((values) => values.length === 0);
